import { FileTypes } from 'api/services/file/types';
import { FormType, IForm, IFormView } from 'shared/Form/types';

export const seoFields: IForm = {
  title: {
    type: FormType.TEXT,
    value: '',
    label: 'Заголовок',
    extraKey: 'title',
  },
  description: {
    type: FormType.TEXTAREA,
    label: 'Описание',
    value: '',
    extraKey: 'description',
  },
  keywords: {
    type: FormType.TEXTAREA,
    value: '',
    label: 'Ключевые слова',
    extraKey: 'keywords',
  },
  ogImage: {
    type: FormType.FILE,
    value: '',
    fileType: FileTypes.IMAGE,
    label: 'Картинка для соц сетей',
    extraKey: 'ogImage',
  },
};

export const seoView: IFormView = [
  {
    title: 'SEO',
    block: [['title'], ['description'], ['keywords'], ['ogImage']],
  },
];

export interface ISeoPayload {
  title: string;
  description: string;
  keywords: string;
  ogImage: string;
}
